












































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';

import { IDepartment } from '../../models';
import { BaseDetail } from '../Base/BaseDetail';

const namespace = 'department';
const ns = { namespace };

@Component
export default class DepartmentDetail extends BaseDetail<IDepartment> {
  namespace = namespace;
  @State('entities', ns) entities: Record<string, IDepartment>;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  mounted() {
    this.loadEntity()?.then(() => {
      this.setValue(this.entityPatch, 'id', Number(this.entityId));
    });
  }
}
